export const DRAG_OPTIONS = {
  animation: 200,
  disabled: false,
  itemKey: (element: string) => element,
  group: {
    name: 'tabs',
    put: false,
    pull: true,
  },
}

export const DEEP_MARGIN = 12

export const DELETE_CONFIG_CONFIRMATION_TITLE = 'Delete configuration'
export const DELETE_CONFIG_CONFIRMATION_TEXT =
  'Are you sure you want to delete this configuration?'
